import { AddGpoForm } from '../../../../pages/AddGpo/AddGpoForm'
import { Form } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { GPOItem } from '../../Gpo/types'
import { initialState } from '../../../../pages/AddGpo/constants'
import { getGpoDetailsList } from '../../Gpo/api'
import { useSelector } from 'react-redux'
import { getUser } from '../../../../redux/store/user/getters'

export const EditGpoDetails = () => {
  const user = useSelector(getUser)
  const [form] = Form.useForm()

  const [details, setDetails] = useState<GPOItem>(initialState)

  const getPredefinedData = useCallback(async () => {
    const res = await getGpoDetailsList(user.gpo)
    setDetails(res?.data)
    form.setFieldsValue({
      ...res.data,
      phone_number: res.data.phone_number?.replace('+1', '')
    })
  }, [form, user])

  useEffect(() => {
    if (user?.gpo) getPredefinedData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return (
    <div>
      <AddGpoForm form={form} details={details} isEdit isGeneral />
    </div>
  )
}
